import React from 'react';
import glamorous from 'glamorous';

import withPrismJs from '../with-prismjs-hoc';
import Fields from './fields';
import { MENU_ENTRIES } from '../constants';

const FieldsDescription = ({ onSectionChange }) => {
  return (
    <div data-subsection={MENU_ENTRIES.fieldsDescription}>
      <h3>
        FIELD DESCRIPTIONS
      </h3>
      <br/>
      <div>
        By default, all fields marked as MANDATORY <strong>MUST</strong> be present in the description of a recall.
      </div>
      <div>
        All fields marked as OPTIONAL are not required to be present in the description of a recall.
      </div>
      <br/>
      <glamorous.Div css={{ fontWeight: 'bold', '& code': { fontWeight: 'normal' } }}>
        Best practice:
        <br/>
        <glamorous.Ul
          className="pt-list"
          css={{
            listStyle: 'disc',
          }}
        >
          <li>
            Do not insert any optional fields in the XML file if there is no data inside.
          </li>
        </glamorous.Ul>
        <glamorous.Div css={{ marginLeft: 10, marginTop: 5 }}>
          <ul className="pt-list">
            <li>
              OK: <code>{`<manufacturer_website>http://fake.com</manufacturer_website>`}</code>.
            </li>
            <li>
              Not OK: <code>{`<manufacturer_website></manufacturer_website>`}</code> if there is no website.
            </li>
          </ul>
        </glamorous.Div>
      </glamorous.Div>
      <br/>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> The content of ALL fields MUST be HTML-encoded (see section: <a
        onClick={e => onSectionChange(MENU_ENTRIES.htmlEncoding)}>HTML Encoding</a>). <strong>You MUST respect the order
        of the fields, as presented in this guide.</strong>
      </p>
      <br/>
      <p>
        <strong>
          This section provides a description of each field (mandatory and optional) accepted by
          the <i>GlobalRecalls</i> portal.
        </strong>
      </p>
      <br/>
      <Fields onSectionChange={onSectionChange}/>
    </div>
  );
};

export default withPrismJs(FieldsDescription);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/field-description/index.js